const allAppDependencies = [];

/*****
 * 
 */
allAppDependencies.push("ipCookie");

/*****
 * 
 */
allAppDependencies.push("gettext");

/*****
 * 
 */
allAppDependencies.push("ui-notification");

/*****
 * 
 */
import '../../../libs/cms/ApiHandler.js';

allAppDependencies.push("ApiHandler");
/* ... joka vaarii */ allAppDependencies.push("ui-notification","ipCookie");

/*****
 * 
 */

/* angular.module("artestUserAssets", [
	'gettext'
]) */
import '../../../libs/cms/ArtestUserAssets.js';
allAppDependencies.push("artestUserAssets");
/* ... joka vaarii */ allAppDependencies.push("gettext");


/* angular.module("artest.preview.query", [
	'ui-notification','ipCookie','ApiHandler'
]) */
import '../../../libs/cms/ArtestPreviewQuery.js';
allAppDependencies.push("artest.preview.query");
/* ... joka vaarii */ allAppDependencies.push("ui-notification","ipCookie","ApiHandler");


/* angular.module("artest.user.bar", [
	"artest.cookie_notify",
	"artest.preview.query",
	"gettext",
	"ui-notification",
	"ui.bootstrap",
	"ApiHandler",
	"ipCookie",
	"artestUserAssets"
]); */
import '../../../libs/cms/ArtestUserBar.js';
allAppDependencies.push("artest.user.bar");
/* ... joka vaarii */ allAppDependencies.push("artest.cookie_notify","artest.preview.query","artestUserAssets","gettext","ui-notification","ui.bootstrap","ApiHandler","ipCookie");


/* angular.module("artest.cookie_notify", [
    "ui-notification","ipCookie","gettext"
]) */
allAppDependencies.push("artest.cookie_notify");
/* ... joka vaarii */ allAppDependencies.push("ui-notification","ipCookie","gettext");

/*****
 * 
 */
allAppDependencies.push("ui.router");

/*****
 * 
 */
allAppDependencies.push("ui.bootstrap");

/*****
 * 
 */
import '../../../libs/dashboard/js/directives.js'
//allAppDependencies.push("dashboardApp.directives");

import '../../../libs/dashboard/src/js/modules/listPagination.js';

import SearchHistoryService from '../../../libs/cmsserver/src/js/services/SearchHistoryService.js';

angular.module( 'artestListPagination' ).service( 'searchHistory', SearchHistoryService );

/*****
 * 
 */
allAppDependencies.push("schemaForm");

/*****
 * 
 */
allAppDependencies.push("angularSchemaFormBase64FileUpload");

/*****
 * 
 */
import { ajsCatalogsModule } from '../features/catalogs/ajs.catalogs.module.js';
allAppDependencies.push( ajsCatalogsModule );

export const appDependencies = allAppDependencies.filter(( dep, idx, deps ) => deps.indexOf( dep ) === idx );
